export const branchListTitles = [
  {
    titleName: "id",
    colWidth: "30px",
  },
  { titleName: "Branch name", colWidth: "150px", key: "name" },
  { titleName: "Address", colWidth: "150px", key: "address" },
  { titleName: "Established date", colWidth: "180px", key: "establisedDate" },
];
